import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { QuickBuild } from 'src/app/people/quick-build.service';
import {
  JobStartsAndEndsConfig,
  PrevNextFlowConfig,
  DemographicsConfig,
  DemographicsCurrentConfig,
  LocationMapConfig,
  TenureCurrentBreakdownConfig,
} from 'src/app/shared/report-visualizations/interfaces/report-config.interfaces';

interface InDepthChartConfigurations {
  'talent-flow'?: PrevNextFlowConfig;
  'job-starts-and-ends'?: JobStartsAndEndsConfig;
  'demographics-over-time'?: DemographicsConfig;
  'current-demographics'?: DemographicsCurrentConfig;
  'location-map'?: LocationMapConfig;
  'tenure-current-breakdown'?: TenureCurrentBreakdownConfig;
  'people-grid'?: any;
}

@Component({
  selector: 'app-in-depth-dashboard',
  templateUrl: './in-depth-dashboard.component.html',
  styleUrls: ['./in-depth-dashboard.component.scss'],
  standalone: false,
})
export class InDepthDashboardComponent implements OnChanges {
  @Input() quickBuild: QuickBuild | null = null;
  @Input() dateRangeStrings: [string, string] = ['', ''];
  @Input() reportTarget: string = 'moneyball';
  @Input() chartConfigs: InDepthChartConfigurations = {};

  @Output() configChange = new EventEmitter<{ chartId: string; config: any }>();

  ngOnChanges(changes: SimpleChanges): void {
    // Handle any change detection logic if needed
  }

  onChartConfigChange(chartId: string, config: any) {
    this.configChange.emit({ chartId, config });
  }
}
